export default {
    methods: {
        openPdfBase64(base64) {

            this.openFileBase64(base64, 'application/pdf')
        },
        openFileBase64(base64, contentType) {

            this.openFile(this.base64ToFile(base64), contentType)
        },
        openFile(content, contentType = 'Application/pdf') {

            const blob = new Blob([content], { type: contentType })
            const url = URL.createObjectURL(blob)
            const link = document.createElement('a')

            link.href = url
            link.target = '_blank'
            link.click()
            link.remove()
        },
        downloadPdfBase64(base64, fileName) {

            this.downloadFileBase64(base64, 'application/pdf', fileName)
        },
        downloadFileBase64(base64, contentType, fileName = 'arquivo') {

            const link = document.createElement("a")

            link.href = `data:${contentType};base64,${base64}`
            link.download = `${fileName}.pdf`

            link.click()
            link.remove()
        },
        fileToBase64(file) {

            return new Promise((resolve, reject) => {

                const reader = new FileReader()

                reader.onload = () => resolve(reader.result.replace(/^data:.+;base64,/, ''))
                reader.onerror = error => reject(error)

                reader.readAsDataURL(file)
            })
        },
        base64ToFile(data) {

            var bString = window.atob(data);
            var bLength = bString.length;
            var bytes = new Uint8Array(bLength);

            for (var i = 0; i < bLength; i++) {

                var ascii = bString.charCodeAt(i);
                bytes[i] = ascii;
            }

            return bytes;
        },
    }
}